<template>
     <a class="dropdown-item" href="#" @click.prevent="logout">
         <i class="mr-1 flaticon-power-button"></i> <span>تسجيل الخروج</span>
      </a>
</template>

<script>
import baseApi from '@/baseApi'
import { mapGetters } from 'vuex'
import store from '@/store'
import router from '@/router'


export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    ...mapGetters({
      isAuth: 'SET_AUTH',
      user: 'SET_AUTH_USER',
      trans: 'GET_TRANS'
    })
  },
  data() {
    return {
      error: {
        auth: ''
      }
    };
  },
  methods: {
      
isAppleDevice() {
  return /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
}
,
localStorageAvailable() {
  try {
    const test = '__storage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
},
 removeData(key) {
  if (this.isAppleDevice() && !this.localStorageAvailable()) {
    // Remove data from cookies
    document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  } else {
    // Remove data from localStorage
    localStorage.removeItem(key);
  }
},
    logout(){
        baseApi().post('/parent-logout').then((response)=>{
            if(response.data.code == 200){
                this.removeData('token');
                this.removeData('auth');
                this.$cookies.remove('token');
                this.$cookies.remove('user');
                this.$cookies.remove('role');
                window.location.href = '/parent-login';

            }else if(response.data.code == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
    },
    profile() {
      this.$router.push({name : 'profile.info'})
    }
  }
};
</script>
